import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setMessage } from "../../features/alertSlice";
import { startSpinner, endSpinner } from "../../features/spinnerSlice";
import { requestData } from "../helpers/requestData";
import { updateParticipantFromClientAction } from "../../features/participantSlice";

const Home = () => {
    const dispatch = useDispatch();
    const alertMessage = useSelector((state) => state.alert.alertMessage);
    const loading = useSelector((state) => state.spinner.loading);

    let [updateParticipantFromClient, setUpdateParticipantFromClient] = useState();

    // Get Data Query from URL Here
    // Check the vid is Present
    // call the create Participant API

    let allRequestData = requestData(window);

    let c1Search = getUrlParam('rid', 'Empty');
    let c2Search = getUrlParam('pid', 'Empty');
    let c3Search = getUrlParam('memberId', 'Empty');

    useEffect(() => {
        if (alertMessage === "" && allRequestData.badUrlHitting) {
            dispatch(setMessage({ success: false, message: "You are hitting a bad url." }))
        };

    }, [alertMessage, allRequestData.badUrlHitting, dispatch]);

    // Call the Create Participant API

    useEffect(() => {
        if (!updateParticipantFromClient && !allRequestData.badUrlHitting) {
            // call action of API
            let allQueryParams = allRequestData.urlQueryString;
            let landingURL = allRequestData.landingURL;
            setUpdateParticipantFromClient(true);

            // Start spinner
            dispatch(startSpinner());

            // Dispatch async thunk
            dispatch(updateParticipantFromClientAction({ allQueryParams, landingURL }))
                .unwrap()
                .then((result) => {
                    dispatch(endSpinner());

                    if (result.type === "MESSAGE") {
                        dispatch(setMessage({ success: result.success, message: result.message }));
                    } else if (result.type === "REDIRECT") {
                        window.location.href = result.redirectURL;
                    }
                })
                .catch((error) => {
                    dispatch(endSpinner());
                    dispatch(setMessage({ success: false, message: error.message || "An error occurred" }));
                });
        }
    }, [updateParticipantFromClient, allRequestData.badUrlHitting, allRequestData.urlQueryString, allRequestData.landingURL, dispatch])

    return (
        (c1Search.startsWith("SS") || c2Search.startsWith("SS") ||
            c1Search.startsWith("NBL") ||
            c3Search.startsWith("NBL") ||
            c2Search.startsWith("NBL")) === 1 ?
            <div>

            </div>
            :
            <div className="processing-container">
                {/* Confetti particles */}
                <div className="confetti"></div>
                <div className="confetti"></div>
                <div className="confetti"></div>
                <div className="confetti"></div>
                <div className="confetti"></div>
                <div className="confetti"></div>
                <div className="confetti"></div>
                <div className="confetti"></div>
                <div className="confetti"></div>

                {/* Show spinner when loading, otherwise show success icon */}
                {loading ? (
                    <div className="loader-spinner"></div>
                ) : (
                    <div className="success-icon">🎉</div>
                )}

                {/* Main Content */}
                <h1 className="congratulations-title">Congratulations!</h1>
                <h2 className="congratulations-subtitle">Survey Completed Successfully</h2>
                <p className="congratulations-message">
                    Thank you for completing the survey. Your opinion helps shape the world around you.
                </p>
                <p className="warning-message">
                    ⚠️ Please do not close this window or refresh the page
                </p>
            </div>
    )
}

function getUrlParam(parameter, defaultvalue) {
    var urlparameter = defaultvalue;
    if (window.location.href.indexOf(parameter) > -1) {
        urlparameter = getUrlVars()[parameter];
    }
    return urlparameter;
}

function getUrlVars() {
    var vars = {};
    window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function (m, key, value) {
        vars[key] = value;
    });
    return vars;
}

export default Home;
